<template>
	<div class="md-theme-default">
		<div id="globalBannerContainer" :style="{top: bannerTop+'px'}">
			<transition name="banner-fade" mode="out-in">
				<banner
					:content="getBannerContent"
					:layout="getBannerContent.layout"
					v-if="bannerVisible"
					@closeBanner="closeGlobalBanner"
					key="bannerVisible"
				/>
			</transition>
		</div>
		<div class="container workflow-app">
			<Nav />
			<router-view />
		</div>
		<share-modal v-if="isOpenShareModal" />
	</div>
</template>

<script>
import throttle from 'lodash.throttle';

import Nav from '@/components/Nav.vue';
import ShareModal from '@/components/modals/share/ShareModal.vue';
export default {
	name: 'App',
	components: {
		Nav,
		ShareModal,
	},
	data() {
		return {
			bannerVisible: false,
			bannerTop: 0,
			banner: {
				title: '',
				body: '',
				version: '',
				btn: '',
				btnEmits: '',
				layout: '',
			},
			calculateBannerTopFunc: throttle(this.calculateBannerTop, 50),
		};
	},
	created() {
		this.$root.$on('showGlobalBanner', this.showGlobalBanner);
		this.$root.$on('closeGlobalBanner', this.closeGlobalBanner);
		localStorage.setItem('registrationOriginApplication', JSON.stringify({value: 'WFC', timestamp: Date.now()}));
	},
	mounted() {
		window.addEventListener('scroll', this.calculateBannerTopFunc);
	},
	unmounted() {
		window.removeEventListener('scroll', this.calculateBannerTopFunc);
	},

	computed: {
		getBannerContent() {
			return this.banner;
		},
		isOpenShareModal() {
			return this.$store.getters['featureShare/isOpen'];
		},
	},
	methods: {
		showGlobalBanner(obj) {
			this.banner = obj;
			this.bannerVisible = true;
			this.calculateBannerTop();
			this.trackHeaderBannerClose(); // fix case of closing header banner with open global banner
		},
		closeGlobalBanner() {
			this.banner = {
				title: '',
				body: '',
				version: '',
				btn: '',
				btnEmits: '',
			};
			this.bannerVisible = false;
			this.calculateBannerTop();
		},

		calculateBannerTop() {
			if (this.bannerVisible) {
				const header = document.querySelector('web-component[_selector="wca-header"]');
				if (!header) return;

				const stickyHeader = header.querySelector('.sc-header.header__navbar-container');
				const bannerHeader = header.querySelector('wca-header-banner');

				if (!stickyHeader) return;

				const isSticky = stickyHeader.classList.contains('header__navbar-container--sticky') || false;
				
				const bannerHeight = bannerHeader?.getBoundingClientRect()?.height || 0;
				
				const stickyHeight = stickyHeader?.getBoundingClientRect()?.height || 0;
				
				if (isSticky) {
					this.bannerTop = stickyHeight;
				} else {
					this.bannerTop = ((bannerHeight + stickyHeight) - window.scrollY);
				}
			}
		},
		trackHeaderBannerClose() {
			const isBannerClose = () => !document.querySelector('web-component[_selector="wca-header"] wca-header-banner .header-banner');
			const checkIsClose = () => {
				if (isBannerClose() || !this.bannerVisible) {
					this.calculateBannerTop();
				} else {
					setTimeout(checkIsClose, 200);
				}
			};
			setTimeout(checkIsClose, 200);
			
		},
	},
};
</script>

<style lang="scss">
@import './assets/scss/main.scss';
#globalBannerContainer {
	position: absolute;
	z-index: 1000;
	.banner {
		position: fixed;
		width: 100%;
		z-index: 10001;
		box-shadow: $banner-shadow;
	}
}
.container {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 1170px;

	@media (min-width: 1251px) {
		max-width: 1266px;
	}
	&.workflow-app {
		min-height: calc(100vh - 351px);
		position: relative;
		@media (max-width: $mobile) {
			padding-bottom: 64px;
		}
	}
	.md-button:before {
		will-change: auto;
	}
}
</style>
